import {
  facebook,
  linkedin,
  star,
  service3,
  go,
  java,
  html,
  css,
  js,
  swift,
  kotlin,
  mongodb,
  postgre,
  grpc,
  nats,
  rabbit,
  revel,
  react,
} from "../assets";

export const navLinks = [
  {
    id: "projects",
    title: "Проекты",
  },
  {
    id: "services",
    title: "Услуги",
  },
  {
    id: "work",
    title: "Как мы работаем",
  },
  {
    id: "about",
    title: "О компании",
  },
  {
    id: "stack",
    title: "Стек технологий",
  },
  {
    id: "contacts",
    title: "Контакты",
  },
];

export const services = [
  {
    id: "service-1",
    icon: service3,
    text: "IT - аутсорсинг",
  },
  {
    id: "service-2",
    icon: service3,
    text: "Дизайн и разработка информационных систем",
  },
  {
    id: "service-3",
    icon: service3,
    text: "Разработка и кастомизация мобильных приложений",
  },
  {
    id: "service-4",
    icon: service3,
    text: "Разработка и кастомизация Web - сервисов и приложений",
  },
  {
    id: "service-5",
    icon: service3,
    text: "Разработка и кастомизация интернет-магазинов",
  },
  {
    id: "service-6",
    icon: service3,
    text: "Разработка чат - ботов для бизнеса",
  },
  {
    id: "service-7",
    icon: service3,
    text: "Техническое сопровождение информационных систем",
  },
];

export const projects = [
  {
    id: "feature-1",
    icon: star,
    title: "QR - way",
    content:
      "Сервис предназначен для формирования гражданами уникального QR-кода для перемещения по городу.",
  },
  {
    id: "feature-2",
    icon: star,
    title: "Sendy Loyalty",
    content:
      "Система для управления программами лояльности клиентов. Единый QR код для совершения платежных операций и механики лояльности.",
  },
  {
    id: "feature-2",
    icon: star,
    title: "E - Comm",
    content:
      "Сервис предоставляет юридическим лицам возможность осуществления торговых операций в интернете.",
  },
];

export const pipline = [
  {
    id: "pipline-1",
    title: "Аналитика",
    content:
      "На первом этапе мы тщательно анализируем требования Заказчика, исследуем рынок и конкурентов, определяем цель, потребности и функциональность проекта.",
    img: service3,
  },
  {
    id: "pipline-2",
    title: "Дизайн",
    content:
      "На втором этапе разрабатываем дизайн будущей информационной системы и формируем техническое задание.",
    img: service3,
  },
  {
    id: "pipline-3",
    title: "Разработка",
    content:
      "После определения функциональности и архитектуры будущего проекта, мы приступаем к разработке нового программного решения.",
    img: service3,
  },
  {
    id: "pipline-4",
    title: "Тестирование",
    content:
      "Готовое решение проверяем на ошибки, производительность и безопасность.",
    img: service3,
  },
  {
    id: "pipline-5",
    title: "Внедрение",
    content: "Разворачиваем готовое решение на инфраструктуре Заказчика.",
    img: service3,
  },
  {
    id: "pipline-6",
    title: "Обучение",
    content:
      "Проводим необходимое обучение специалистов Заказчика, чтобы подготовить их для работы с новым программным продуктом.",
    img: service3,
  },
  {
    id: "pipline-7",
    title: "Поддержка",
    content:
      "Обеспечиваем техническую поддержку готовой системы, а также, при необходимости развиваем и добавляем новую функциональность проекту.",
    img: service3,
  },
];

export const stats = [
  {
    id: "stats-1",
    title: "Лет на рынке",
    value: "17+",
  },
  {
    id: "stats-2",
    title: "Проектов",
    value: "230+",
  },
  {
    id: "stats-3",
    title: "Специалистов",
    value: "180+",
  },
];

export const footerLinks = [
  {
    title: "Контакты",
    links: [
      {
        name: "Адрес: 610002, г. Киров, ул. Володарского, д. 114А",
        link: "info@sendysoft.ru",
      },
      {
        name: "e-mail: info@sendysoft.ru",
        link: "info@sendysoft.ru",
      },
      {
        name: "тел.: +7 925 750 43 69",
        link: "+7 925 750 43 69",
      },
    ],
  },
];

export const socialMedia = [
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/",
  },
  {
    id: "social-media-4",
    icon: linkedin,
    link: "https://www.linkedin.com/",
  },
];

export const stack = [
  {
    id: "stack-1",
    logo: go,
  },
  {
    id: "stack-2",
    logo: java,
  },
  {
    id: "stack-3",
    logo: html,
  },
  {
    id: "stack-4",
    logo: css,
  },
  {
    id: "stack-5",
    logo: js,
  },
  {
    id: "stack-6",
    logo: swift,
  },
  {
    id: "stack-7",
    logo: kotlin,
  },
  {
    id: "stack-8",
    logo: postgre,
  },
  {
    id: "stack-9",
    logo: mongodb,
  },
  {
    id: "stack-10",
    logo: grpc,
  },
  {
    id: "stack-12",
    logo: nats,
  },
  {
    id: "stack-13",
    logo: revel,
  },
  {
    id: "stack-14",
    logo: rabbit,
  },
  {
    id: "stack-15",
    logo: react,
  },
];
